import React from 'react';
import { Col, Row } from 'antd';
import { Divider, Gap, StatePill, Text } from '@common/components';
import { ApplicationFromOfferInfoType } from '@applicant-flow/types';

export function OfferInfoSummary({
  application,
  rate,
  oldRate,
}: {
  rate?: string;
  oldRate?: string;
  application: ApplicationFromOfferInfoType;
}) {
  const { staffingRequest } = application;
  const { organizationUnit } = staffingRequest;

  return (
    <div className="offer-info-summary">
      <Row>
        <Col span={6}>
          ID
          <Text bold block>
            {staffingRequest.code}
          </Text>
        </Col>
        <Col span={12}>
          Role - Assignment
          <Text bold block>
            {staffingRequest.role?.abbreviation} -{' '}
            {staffingRequest.staffingRequestType}
          </Text>
        </Col>
        <Col span={6}>
          Rate
          {oldRate && oldRate !== rate ? (
            <Gap align="center">
              <Text deleted color="darkGrey" block>
                {`$${oldRate}`}
              </Text>
              <StatePill color="grass">{`$${rate}`}</StatePill>
            </Gap>
          ) : (
            <Text bold block>{`$${rate}`}</Text>
          )}
        </Col>
      </Row>
      <Divider gutter={16} />
      <div>
        Facility, City, State
        <Text bold block>
          {application.organization.name},{' '}
          {organizationUnit?.department?.organizationBusiness?.city},{' '}
          {organizationUnit?.department?.organizationBusiness?.stateCode}
        </Text>
      </div>
      <Divider gutter={16} />
      <div>
        Unit - Facility
        <Text bold block>
          {organizationUnit?.department?.name},{' '}
          {organizationUnit?.department?.organizationBusiness?.name}
        </Text>
      </div>
      <Divider gutter={16} />
    </div>
  );
}
